<template>
  <el-container style="width: 100%">
    <el-header>
      <el-button round @click="createClick">{{generateCustomizeString('add')}}</el-button>
    </el-header>
    <el-table :data="adBannerData" tooltip-effect="dark" style="width: 96%; margin: 10px auto; margin-bottom:60px;">
      <el-table-column :label="generateCustomizeString('bannerImg')" width="360">
        <template slot-scope="scope">
          <img :src="scope.row.pic_url" style="width:auto;height:100px;" />
        </template>
      </el-table-column>
      <el-table-column prop="redirect_url" :label="generateCustomizeString('linkUrl')">
      </el-table-column>

      <el-table-column prop="sort_by" :label="generateCustomizeString('sortWeight')">
      </el-table-column>
      <el-table-column prop="created_at" :label="generateCustomizeString('createAt')">
      </el-table-column>
      <el-table-column prop="is_show" :label="generateCustomizeString('bannerActivity')">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_show === 1" type="success" close-transition>
            {{generateCustomizeString('moduleReady')}}
          </el-tag>
          <el-tag v-else type="info" close-transition>
            {{generateCustomizeString('moduleWaitForReview')}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" :label="generateCustomizeString('operate')" width="180">
        <template slot-scope="scope">
          <el-button @click="editClick(scope.row)" type="text" size="small">{{generateCustomizeString('edit')}}</el-button>
          <el-button @click="deleteClick(scope.row)" type="text" size="small">{{generateCustomizeString('delete')}}</el-button>
          <el-dialog :title="generateCustomizeString('noticeConfirm')" :visible.sync="dialogVisible" width="30%" :append-to-body="true">
            <span>{{generateCustomizeString('deleteBanner')}}</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">{{generateCustomizeString('deleteCancel')}}</el-button>
              <el-button type="primary" @click="deleteBanner()">{{generateCustomizeString('deleteConfirm')}}</el-button>
            </span>
          </el-dialog>
        </template>
      </el-table-column>
    </el-table>
    <el-footer style="position: fixed; bottom: 0; width: 100%; z-index:9999; padding-top:15px;">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="15" layout="total, prev, pager, next" :total="currentTotal">
      </el-pagination>
    </el-footer>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import dayjs from 'dayjs'

export default {
  name: 'PcAdBanner',
  data() {
    return {
      adBannerData: [],
      selectDeleteId: 0,
      currentPage: 1,
      currentTotal: 0,
      dialogVisible: false
    }
  },
  methods: {
    generateCustomizeString,
    handleCurrentChange(val) {
      this.fetchData(val)
    },
    editClick(row) {
      this.$router.push({
        name: 'EditAdBanner',
        params: {
          bannerId: row.id
        }
      })
    },
    createClick() {
      this.$router.push({
        name: 'CreateAdBanner'
      })
    },
    deleteClick(row) {
      this.selectDeleteId = row.id
      this.dialogVisible = true
    },
    fetchData(page) {
      if (this.fetchLoding) return
      this.fetchLoding = true

      request({
        url: '/cms-category-items?type=2',
        method: 'get',
        params: {
          page: page
        }
      })
        .then(response => {
          const data = response.data
          const meta = response.meta
          for (let i = 0; i < response.data.length; i++) {
            var obj = {}
            obj.id = response.data[i].id
            if (response.data[i].pic_url) {
              obj.pic_url =
                response.data[i].pic_url +
                '?imageView2/5/w/500/h/150/q/75|imageslim'
            }
            obj.redirect_url = response.data[i].redirect_url
            obj.sort_by = response.data[i].sort_by
            obj.created_at = response.data[i].created_at.replace(/-/g, '/')
            obj.created_at = dayjs(new Date(obj.created_at + ' UTC')).format('YYYY-M-D HH:mm:ss')
            obj.is_show = response.data[i].is_show
            data[i] = obj
          }
          this.adBannerData = data
          this.currentPage = meta.current_page
          this.currentTotal = meta.total
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.fetchLoding = false
        })
    },
    deleteBanner() {
      if (this.selectDeleteId === 0) return
      request({
        url: 'cms-category-item/' + this.selectDeleteId,
        method: 'delete'
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('deletedSuccessfully'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('deleteFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('deleteFailed'))
        })
        .finally(() => {
          this.fetchData(this.currentPage)
          this.dialogVisible = false
          this.selectDeleteId = 0
        })
    }
  },
  created: function() {
    this.fetchData()
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-header,
.el-footer {
  background-color: #efefef;
  // color: #333;
  text-align: left;
  line-height: 60px;
}
</style>
